import React from 'react';
import { Layout, Button, Space, Badge, Typography, Dropdown, Avatar } from 'antd';
import type { MenuProps } from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  UserOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import useUIStore from '../../stores/uiStore';
import useAuthStore from '../../stores/authStore';
import useTenantStore from '../../stores/tenantStore';

const THEME = {
  sidebarBg: '#1B3A5C',
  sidebarActiveBg: '#3DA872',
  sidebarHover: '#1A6E8C',
  headerBg: '#FFFFFF',
  contentBg: '#F5F6FA',
  brandPrimary: '#1A6E8C',
  textOnDark: '#FFFFFF',
  textOnDarkMuted: '#B0C4D8',
} as const;

const { Header } = Layout;
const { Text } = Typography;

export default function AppHeader(): React.ReactElement {
  const { sidebarCollapsed, toggleSidebar } = useUIStore();
  const user = useAuthStore((s) => s.user);
  const tenant = useTenantStore((s) => s.tenant);

  const handleLogout = async () => {
    await signOut(auth);
  };

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: `${user?.prenom ?? ''} ${user?.nom ?? ''}`,
      disabled: true,
    },
    { type: 'divider' },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Se déconnecter',
      onClick: handleLogout,
    },
  ];

  return (
    <Header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#fff',
        borderBottom: '1px solid #f0f0f0',
        padding: '0 24px',
        height: 64,
      }}
    >
      <Button
        type="text"
        icon={
          sidebarCollapsed
            ? <MenuUnfoldOutlined style={{ color: THEME.brandPrimary }} />
            : <MenuFoldOutlined style={{ color: THEME.brandPrimary }} />
        }
        onClick={toggleSidebar}
        style={{ fontSize: 16 }}
      />

      <Space>
        {tenant.email_provider_status === 'error' && (
          <Badge
            count={<WarningOutlined style={{ color: '#faad14' }} />}
            title="Le fournisseur email est en erreur — accédez aux paramètres."
          >
            <Text type="warning" style={{ fontSize: 13 }}>
              Email hors service
            </Text>
          </Badge>
        )}

        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <Avatar
            style={{ backgroundColor: tenant.primary_color ?? THEME.brandPrimary, cursor: 'pointer' }}
            size={36}
          >
            {user?.initiales ?? (user?.prenom?.[0] ?? '?').toUpperCase()}
          </Avatar>
        </Dropdown>
      </Space>
    </Header>
  );
}
